// extracted by mini-css-extract-plugin
export default {"circle":"style_circle__nitLX","circle-canvas":"style_circle-canvas__VKrOR","circle-percentage":"style_circle-percentage__dLOZ3"};